import { render } from "./TemplateMyTicketsIndex.vue?vue&type=template&id=7832422a"
import script from "./TemplateMyTicketsIndex.vue?vue&type=script&lang=js"
export * from "./TemplateMyTicketsIndex.vue?vue&type=script&lang=js"
script.render = render

export default script